"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MGRSConstants = void 0;
const grid_js_1 = require("@ngageoint/grid-js");
/**
 * Military Grid Reference System Constants
 */
class MGRSConstants {
}
exports.MGRSConstants = MGRSConstants;
/**
 * Minimum longitude
 */
MGRSConstants.MIN_LON = grid_js_1.GridConstants.MIN_LON;
/**
 * Maximum longitude
 */
MGRSConstants.MAX_LON = grid_js_1.GridConstants.MAX_LON;
/**
 * Minimum latitude
 */
MGRSConstants.MIN_LAT = -80.0;
/**
 * Maximum latitude
 */
MGRSConstants.MAX_LAT = 84.0;
/**
 * Minimum grid zone number
 */
MGRSConstants.MIN_ZONE_NUMBER = 1;
/**
 * Maximum grid zone number
 */
MGRSConstants.MAX_ZONE_NUMBER = 60;
/**
 * Grid zone width
 */
MGRSConstants.ZONE_WIDTH = 6.0;
/**
 * Minimum grid band letter
 */
MGRSConstants.MIN_BAND_LETTER = 'C';
/**
 * Maximum grid band letter
 */
MGRSConstants.MAX_BAND_LETTER = 'X';
/**
 * Number of bands
 */
MGRSConstants.NUM_BANDS = 20;
/**
 * Grid band height for all by but the {@link #MAX_BAND_LETTER}
 */
MGRSConstants.BAND_HEIGHT = 8.0;
/**
 * Grid band height for the {@link #MAX_BAND_LETTER}
 */
MGRSConstants.MAX_BAND_HEIGHT = 12.0;
/**
 * Last southern hemisphere band letter
 */
MGRSConstants.BAND_LETTER_SOUTH = 'M';
/**
 * First northern hemisphere band letter
 */
MGRSConstants.BAND_LETTER_NORTH = 'N';
/**
 * Min zone number in Svalbard grid zones
 */
MGRSConstants.MIN_SVALBARD_ZONE_NUMBER = 31;
/**
 * Max zone number in Svalbard grid zones
 */
MGRSConstants.MAX_SVALBARD_ZONE_NUMBER = 37;
/**
 * Band letter in Svalbard grid zones
 */
MGRSConstants.SVALBARD_BAND_LETTER = MGRSConstants.MAX_BAND_LETTER;
/**
 * Min zone number in Norway grid zones
 */
MGRSConstants.MIN_NORWAY_ZONE_NUMBER = 31;
/**
 * Max zone number in Norway grid zones
 */
MGRSConstants.MAX_NORWAY_ZONE_NUMBER = 32;
/**
 * Band letter in Norway grid zones
 */
MGRSConstants.NORWAY_BAND_LETTER = 'V';
//# sourceMappingURL=MGRSConstants.js.map